/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "What this agent is for, in one sentence." |
*
* @param {Agent_Builder_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_description_placeholder = /** @type {((inputs?: Agent_Builder_Description_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Description_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wofür dieser Agent da ist, in einem Satz.")
	return /** @type {LocalizedString} */ ("What this agent is for, in one sentence.")
});